import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';

export const getNotificationList = async (page, limit, search, name, title) => {
  const baseUrl = `${API_CONSTANTS.NOTIFICATION}/list`;
  const queryParams = [];

  if (page) queryParams.push(`page=${page}`);
  if (limit) queryParams.push(`limit=${limit}`);
  if (search) queryParams.push(`search=${search}`);
  if (name) queryParams.push(`name=${name}`);
  if (title) queryParams.push(`title=${title}`);

  const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
  const url = `${baseUrl}${queryString}`;

  let responseObj = await dataAccess.get(url);
  return responseObj;
};

export const addNotification = async (incomingData) => {
  let payload = {
    data: {
      ...incomingData,
    },
  };

  let responseObj = await dataAccess.post(
    `${API_CONSTANTS.NOTIFICATION}/add`,
    payload
  );

  return responseObj;
};

export const deleteNotification = async (id) => {
  let url = `${API_CONSTANTS.NOTIFICATION}/delete?id=${id}`;

  let responseObj = await dataAccess.del(url);
  return responseObj;
};

export const updateNotification = async (id, incomingData) => {
  let url = '';
  url = `${API_CONSTANTS.NOTIFICATION}/update?DetailId=${id}`;

  let payload = {
    data: {
      ...incomingData,
    },
  };

  let responseObj = await dataAccess.put(url, payload);
  return responseObj;
};

export const getNotificationById = async (id) => {
  let url = `${API_CONSTANTS.NOTIFICATION}/detail?id=${id}`;
  let responseObj = await dataAccess.get(url);
  return responseObj;
};
export const getWhatsappCampaignList = async () => {
  let responseObj = await dataAccess.get(
    `${API_CONSTANTS.NOTIFICATION}/campaign-list`
  );
  return responseObj;
};
